/* istanbul ignore file */
import * as React from 'react'
import Head from 'next/head'
import getConfig from 'next/config'
import Script from 'next/script'

/* eslint-disable max-len */
const ThirdPartyScripts = (): React.ReactElement<any> => {
  const { publicRuntimeConfig } = getConfig()
  const {
    gtm: { authKey, preview, containerId },
    embeddedChat: {
      bootstrapSrc,
      orgId,
      configName,
      scrt2Url
    }
  } = publicRuntimeConfig

  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          dataLayer = [];
          (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=${authKey}&gtm_preview=${preview}&gtm_cookies_win=x';
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${containerId}');
        `,
          }}
        />
      </Head>
      <noscript>
        <iframe
          title="NoScript Google Tag Manager"
          src={`https://www.googletagmanager.com/ns.html?id=${containerId}&gtm_auth=${authKey}&gtm_preview=${preview}&gtm_cookies_win=x`}
          height="0"
          width="0"
          style={{
            display: 'none',
            visibility: 'hidden',
          }}
        />
      </noscript>
      {
        bootstrapSrc && orgId && configName && scrt2Url ? (
          <Script
            src={`${bootstrapSrc}/assets/js/bootstrap.min.js`}
            strategy="afterInteractive"
            onLoad={() => {
              const initializeEmbeddedMessaging = () => {
                window.embeddedservice_bootstrap.settings.language = 'nl_NL'; // For example, enter 'en' or 'en-US'

                window.embeddedservice_bootstrap.init(
                  orgId,
                  configName,
                  bootstrapSrc,
                  {
                    scrt2URL: scrt2Url
                  }
                );
              }

              initializeEmbeddedMessaging()
            }}
          />
        ) : null
      }
      <script
        dangerouslySetInnerHTML={{
          __html: `
              (function(h,o,t,j,a,r) {
                h.hj=h.hj||function() {(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:3320059,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              `,
        }}
      />
    </>
  )
}

export default ThirdPartyScripts
